import { computed, defineComponent, ref, watch, nextTick } from '@vue/composition-api';
import { Form, Field } from 'components/forms';
import { BfButton, BfTextInput } from 'components/Butterfly';
import Modal from 'src/components/project/analysis/results/Modal.vue';
const ThemeNameModal = defineComponent({
    components: {
        Form,
        Field,
        BfButton,
        BfTextInput,
        Modal,
    },
    props: {
        visible: { type: Boolean, required: true },
        values: { type: Object, required: true },
        submitErrors: { type: Array, required: true },
    },
    setup(props, { emit }) {
        const form = ref();
        // Set form to current query values when modal is opened
        watch(() => props.visible, (newVal, oldVal) => {
            if (!oldVal && newVal) {
                nextTick(() => {
                    form.value && form.value.resetForm({ ...props.values });
                });
            }
        });
        const saveOrRename = (form) => {
            const data = { ...form };
            emit('submit', data);
        };
        const initialFormValues = computed(() => {
            return {
                name: props.values.name ?? '',
            };
        });
        return {
            saveOrRename,
            initialFormValues,
            form,
        };
    },
});
export default ThemeNameModal;
